import cookie from 'react-cookies';
import { HOME_SAVE_TOKEN_FROM_ORGANIZATION } from '../../features/home/redux/constants';
import { Mixpanel } from '../../common/utils/mixpanelUtil';

function checkAuthorization(dispatch) {
  const token = cookie.load('token');
  if (token) {
    //Verify Token is valid or not
    dispatch({
      type: HOME_SAVE_TOKEN_FROM_ORGANIZATION,
      token,
    });
    return { access: true };
  }
  return { access: false };
}

export const checkWidgetAuthorization = ({ dispatch, getState }, ...rest) => {
  const { token } = getState().home;
  if (token) {
    return {
      access: true,
    };
  }
  return checkAuthorization(dispatch);
};

export const checkLocationTokenAndAuthorize = (store, rest) => {
  let search = rest.location.search;
  let token = cookie.load('token');
  if (!token) {
    token = search.split('=')[1];
  }
  if (token) {
    const expires = new Date();
    expires.setDate(Date.now() + 1000 * 60 * 60 * 24);
    cookie.save('token', token, { path: '/', expires });
    store.dispatch({
      type: HOME_SAVE_TOKEN_FROM_ORGANIZATION,
      token: token,
    });
    return { access: true };
  }
  return { access: false };
};

export const saveCookie = (user, organization) => {
  const { authorities, username, displayName, uuid } = user;
  const expires = new Date();
  expires.setDate(Date.now() + 1000 * 60 * 60 * 24);
  cookie.save('username', username, { path: '/', expires });
  cookie.save('uuid', uuid, { path: '/', expires });
  cookie.save('role', authorities[0], { path: '/', expires });
  cookie.save('isLoggedIn', true, { path: '/', expires });
  cookie.save('name', displayName, { path: '/', expires });

  //Save Organization Detail
  cookie.save('permissions', organization.permissions, { path: '/', expires });
  cookie.save('subscription', organization.subscription, { path: '/', expires });
  Mixpanel.identify(username);
  Mixpanel.track('Open Builder Config');
};

export const resetCookie = () => {
  Mixpanel.track('Logged Out from Builder Config');
  Mixpanel.reset();
  cookie.remove('username', { path: '/' });
  cookie.remove('uuid', { path: '/' });
  cookie.remove('isLoggedIn', { path: '/' });
  cookie.remove('token', { path: '/' });
  cookie.remove('role', { path: '/' });
  cookie.remove('name', { path: '/' });
  cookie.remove('permissions', { path: '/' });
  cookie.remove('subscription', { path: '/' });
};

export const loadOrganizationDetails = (key) => {
  return cookie.load(key);
};
